// @flow

import {
  getFooterSettings,
} from './main';

export {
  getContactOptions,
  getLogos,
  getFooterTitle,
  getFooterSubtitle,
  getNewsletter,
} from './main';

export default getFooterSettings;
